import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import { ICardElementWithChildren } from "backend/model/model";
import React from "react";
import PerspectiveCardList from "design/components/grids/PerspectiveCardList";
import { IChartSelectEvent } from "../charts/types";
import { ElementOverviewStackedCard } from "../cards/ElementOverviewStackedCard";

const usePerformanceSummaryBarsStyles = makeThemedStyles(
  "PerformanceSummaryBars",
  (theme) => ({
    root: {
      width: "30.4em",
      minHeight: "37.1em",
      fontSize: "10px",
      borderRadius: ".8em",
      border: "1px solid rgba(247, 247, 247, 1)",
    },
    divider: {
      height: "20px",
    },
  })
);

export const PerformanceSummaryBars = React.memo(
  (
    props: React.PropsWithChildren<{
      elements: ICardElementWithChildren[];
      periodName: string;
      title: string;
      typenames: string[];
      onSelect?: (value: IChartSelectEvent) => void;
    }>
  ) => {
    const styles = usePerformanceSummaryBarsStyles();
    return (
      <PerspectiveCardList>
        {props.elements.map((el) => {
          return (
            <ElementOverviewStackedCard
              element={el}
              title={props.title}
              periodName={props.periodName}
              typenames={props.typenames}
              onSelect={props.onSelect}
            />
          );
        })}
      </PerspectiveCardList>
    );
  }
);
